export const draganddrop=[
    {
    "depositAccountDetails": {
      "depositMessage": {
        "depositFilter": {},
        "partyIdList": {
          "partyId": ["14558"]
        },
        "depositList": {
          "deposit": [
            {
              "accountId": "14558:62284915",
              "accountNickName": "",
              "accountNoteList": {
                "note": []
              },
              "actualBalance": {
                "value": 30776.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "availableBalance": {
                "value": 30771.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "branch": "135th & Maple Branch",
              "bumpRate": 0,
              "customData": {
                "valuePair": []
              },
              "depositAccountStatus": "Active",
              "depositAccountSubStatus": "ACT",
              "depositPartyList": {
                "depositParty": []
              },
              "description": "Membership Savings",
              "dividendRate": 0.05,
              "dividendType": "",
              "externalTransferFrom": false,
              "externalTransferTo": false,
              "idType": "Actual",
              "irsCode": "0",
              "meta": {
                "loanMeta": {}
              },
              "micrAccountNumber": "3011802921455862284915",
              "minimumBalance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumDeposit": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumWithdrawal": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "openDate": "2010-07-17T00:00:00+0000",
              "overdraftTolerance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "partyIdList": {
                "partyId": []
              },
              "routingNumber": "301180292",
              "subType": "SAVE",
              "transactionList": {
                "transaction": []
              },
              "transferFrom": true,
              "transferTo": true,
              "type": "Savings"
            }
            ,
            {
              "accountId": "14558:62284715",
              "accountNickName": "",
              "accountNoteList": {
                "note": []
              },
              "actualBalance": {
                "value": 30776.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "availableBalance": {
                "value": 30771.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "branch": "135th & Maple Branch",
              "bumpRate": 0,
              "customData": {
                "valuePair": []
              },
              "depositAccountStatus": "Active",
              "depositAccountSubStatus": "ACT",
              "depositPartyList": {
                "depositParty": []
              },
              "description": "Membership Savings",
              "dividendRate": 0.05,
              "dividendType": "",
              "externalTransferFrom": false,
              "externalTransferTo": false,
              "idType": "Actual",
              "irsCode": "0",
              "meta": {
                "loanMeta": {}
              },
              "micrAccountNumber": "3011802921455852284915",
              "minimumBalance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumDeposit": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumWithdrawal": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "openDate": "2010-07-17T00:00:00+0000",
              "overdraftTolerance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "partyIdList": {
                "partyId": []
              },
              "routingNumber": "301180492",
              "subType": "SAVE",
              "transactionList": {
                "transaction": []
              },
              "transferFrom": true,
              "transferTo": true,
              "type": "Savings"
            },
            {
              "accountId": "14558:62284780",
              "accountNickName": "",
              "accountNoteList": {
                "note": []
              },
              "actualBalance": {
                "value": 30776.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "availableBalance": {
                "value": 30771.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "branch": "135th & Maple Branch",
              "bumpRate": 0,
              "customData": {
                "valuePair": []
              },
              "depositAccountStatus": "Active",
              "depositAccountSubStatus": "ACT",
              "depositPartyList": {
                "depositParty": []
              },
              "description": "Membership Savings",
              "dividendRate": 0.05,
              "dividendType": "",
              "externalTransferFrom": false,
              "externalTransferTo": false,
              "idType": "Actual",
              "irsCode": "0",
              "meta": {
                "loanMeta": {}
              },
              "micrAccountNumber": "3011802921455852284915",
              "minimumBalance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumDeposit": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumWithdrawal": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "openDate": "2010-07-17T00:00:00+0000",
              "overdraftTolerance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "partyIdList": {
                "partyId": []
              },
              "routingNumber": "301180492",
              "subType": "SAVE",
              "transactionList": {
                "transaction": []
              },
              "transferFrom": true,
              "transferTo": true,
              "type": "Savings"
            },
            {
              "accountId": "14558:62287000",
              "accountNickName": "",
              "accountNoteList": {
                "note": []
              },
              "actualBalance": {
                "value": 30776.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "availableBalance": {
                "value": 30771.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "branch": "135th & Maple Branch",
              "bumpRate": 0,
              "customData": {
                "valuePair": []
              },
              "depositAccountStatus": "Active",
              "depositAccountSubStatus": "ACT",
              "depositPartyList": {
                "depositParty": []
              },
              "description": "Membership Savings",
              "dividendRate": 0.05,
              "dividendType": "",
              "externalTransferFrom": false,
              "externalTransferTo": false,
              "idType": "Actual",
              "irsCode": "0",
              "meta": {
                "loanMeta": {}
              },
              "micrAccountNumber": "3011802921455852284915",
              "minimumBalance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumDeposit": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumWithdrawal": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "openDate": "2010-07-17T00:00:00+0000",
              "overdraftTolerance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "partyIdList": {
                "partyId": []
              },
              "routingNumber": "301180492",
              "subType": "SAVE",
              "transactionList": {
                "transaction": []
              },
              "transferFrom": true,
              "transferTo": true,
              "type": "Savings"
            },
            {
              "accountId": "14558:622870640",
              "accountNickName": "",
              "accountNoteList": {
                "note": []
              },
              "actualBalance": {
                "value": 30776.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "availableBalance": {
                "value": 30771.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "branch": "135th & Maple Branch",
              "bumpRate": 0,
              "customData": {
                "valuePair": []
              },
              "depositAccountStatus": "Active",
              "depositAccountSubStatus": "ACT",
              "depositPartyList": {
                "depositParty": []
              },
              "description": "Membership Savings",
              "dividendRate": 0.05,
              "dividendType": "",
              "externalTransferFrom": false,
              "externalTransferTo": false,
              "idType": "Actual",
              "irsCode": "0",
              "meta": {
                "loanMeta": {}
              },
              "micrAccountNumber": "3011802921455852284915",
              "minimumBalance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumDeposit": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumWithdrawal": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "openDate": "2010-07-17T00:00:00+0000",
              "overdraftTolerance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "partyIdList": {
                "partyId": []
              },
              "routingNumber": "301180492",
              "subType": "SAVE",
              "transactionList": {
                "transaction": []
              },
              "transferFrom": true,
              "transferTo": true,
              "type": "Savings"
            },
            {
              "accountId": "14558:622870543",
              "accountNickName": "",
              "accountNoteList": {
                "note": []
              },
              "actualBalance": {
                "value": 30776.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "availableBalance": {
                "value": 30771.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "branch": "135th & Maple Branch",
              "bumpRate": 0,
              "customData": {
                "valuePair": []
              },
              "depositAccountStatus": "Active",
              "depositAccountSubStatus": "ACT",
              "depositPartyList": {
                "depositParty": []
              },
              "description": "Membership Savings",
              "dividendRate": 0.05,
              "dividendType": "",
              "externalTransferFrom": false,
              "externalTransferTo": false,
              "idType": "Actual",
              "irsCode": "0",
              "meta": {
                "loanMeta": {}
              },
              "micrAccountNumber": "3011802921455852284915",
              "minimumBalance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumDeposit": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumWithdrawal": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "openDate": "2010-07-17T00:00:00+0000",
              "overdraftTolerance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "partyIdList": {
                "partyId": []
              },
              "routingNumber": "301180492",
              "subType": "SAVE",
              "transactionList": {
                "transaction": []
              },
              "transferFrom": true,
              "transferTo": true,
              "type": "Savings"
            },
            {
              "accountId": "14558:624326628",
              "accountNickName": "",
              "accountNoteList": {
                "note": []
              },
              "actualBalance": {
                "value": 30776.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "availableBalance": {
                "value": 30771.1,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "branch": "135th & Maple Branch",
              "bumpRate": 0,
              "customData": {
                "valuePair": []
              },
              "depositAccountStatus": "Active",
              "depositAccountSubStatus": "ACT",
              "depositPartyList": {
                "depositParty": []
              },
              "description": "Membership Savings",
              "dividendRate": 0.05,
              "dividendType": "",
              "externalTransferFrom": false,
              "externalTransferTo": false,
              "idType": "Actual",
              "irsCode": "0",
              "meta": {
                "loanMeta": {}
              },
              "micrAccountNumber": "3011802921455852284915",
              "minimumBalance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumDeposit": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "minimumWithdrawal": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "openDate": "2010-07-17T00:00:00+0000",
              "overdraftTolerance": {
                "value": 0,
                "currencyCode": "USD",
                "exchangeRate": 0
              },
              "partyIdList": {
                "partyId": []
              },
              "routingNumber": "301180492",
              "subType": "SAVE",
              "transactionList": {
                "transaction": []
              },
              "transferFrom": true,
              "transferTo": true,
              "type": "Savings"
            }
          ]
        }
      },
      "messageContext": {
        "fiId": "mtcu-dnaws",
        "includeBlankFields": true,
        "includeZeroNumerics": true,
        "user": []
      }
    },
    "loanMessage": {
      "messageContext": {},
      "loanFilter": {},
      "loanList": {}
    }
  }
  
]